<template>
  <div class="callingNumbersManage">
    <div class="header">
      <div class="btn_list">
        <el-button type="primary" @click="editDevice()">新增设备</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" min-width="180"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="180"></el-table-column>
        <el-table-column prop="deviceType" label="设备类型" min-width="140">
          <template slot-scope="scope">
            <div>{{ typeMap[scope.row.deviceType] }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="roomsText" label="关联诊室" min-width="220"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="200"></el-table-column>
        <el-table-column prop="createBy" label="创建人" min-width="160"></el-table-column>
        <el-table-column label="操作" width="240" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="editDevice(scope.row.id)">编辑</el-button>
            <el-button type="danger" plain @click="delDevice(scope.row.id)">删除</el-button>
            <el-button type="primary" plain @click="editRoom(scope.row)">关联诊室</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="设备管理"
      :visible.sync="deviceMap.visible"
      class="deviceDialog"
      width="350px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      :before-close="closeDevice">
      <el-form ref="deviceForm" :model="deviceMap.form" :rules="deviceMap.rules" label-width="100px">
        <el-form-item label="设备编号：">
          <!-- <el-input v-model="deviceMap.form.deviceCode" readonly></el-input> -->
          <div>{{ deviceMap.form.deviceCode }}</div>
        </el-form-item>
        <el-form-item label="设备名称：" prop="deviceName">
          <el-input v-model="deviceMap.form.deviceName"></el-input>
        </el-form-item>
        <el-form-item label="设备类型：">
          <el-radio-group v-model="deviceMap.form.deviceType">
            <el-radio :label="1">大屏</el-radio>
            <el-radio :label="2">小屏</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDevice">取 消</el-button>
        <el-button type="primary" @click="submitDevice">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="关联诊室"
      :visible.sync="roomMap.visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeRoom">
      <div class="room_header">
        <div class="room_btn_list">
          <el-button type="primary" @click="addRoom()">新增诊室</el-button>
        </div>
      </div>
      <div class="room_table">
        <el-table
          :data="roomMap.list"
          border
          max-height="300"
          style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="roomName" label="诊室名称"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" plain @click="delRoom(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="closeRoom">取 消</el-button>
        <el-button type="primary" @click="submitRoom">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="新增诊室"
      :visible.sync="addRoomMap.visible"
      width="350px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeAddRoom">
      <el-form ref="addRoomForm" :model="addRoomMap.form" :rules="addRoomMap.rules" label-width="100px">
        <el-form-item label="诊室名称：" prop="roomId">
          <el-select v-model="addRoomMap.form.roomId" placeholder="请选择诊室">
            <el-option
              v-for="item in addRoomMap.options"
              :key="item.clinicId"
              :label="item.clinicName"
              :value="item.clinicId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeAddRoom">取 消</el-button>
        <el-button type="primary" @click="submitAddRoom">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { clinicList } from "@/api/clinic"
import { getDeviceList, addDevice, updateDevice, delDevice, getDeviceRoomsList, updateDeviceRooms } from '@/api/callingNumbersManage'
export default {
  name: "CallingNumbersManage",
  data() {
    return {
      typeMap: {
        1: '大屏',
        2: '小屏'
      },
      list: [],
      deviceMap: {
        visible: false,
        rules: {
          deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }]
        },
        form: {
          id: '',
          deviceCode: '',
          deviceName: '',
          deviceType: 1
        }
      },
      roomMap: {
        visible: false,
        deviceId: '',
        list: []
      },
      addRoomMap: {
        visible: false,
        rules: {
          roomId: [{ required: true, message: '请选择诊室', trigger: 'change' }]
        },
        form: {
          roomId: ''
        },
        options: []
      }
    }
  },
  methods: {
    async getList() {
      const res = await getDeviceList({ deptId: sessionStorage.getItem('deptId') })
      if (res.code === 200) {
        this.list = res.data.map(v => {
          return {
            ...v,
            roomsText: v.roomList.map(v2 => { return v2.roomName }).join(',')
          }
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    editDevice(id = '') {
      if (id) {
        const device = this.list.find(item => item.id === id)
        if (device) {
          this.deviceMap.form = {
            id: device.id,
            deviceCode: device.deviceCode,
            deviceName: device.deviceName,
            deviceType: device.deviceType
          }
        }
      }
      this.deviceMap.visible = true
      this.$nextTick(() => {
        this.$refs.deviceForm.clearValidate()
      })
    },
    async delDevice(id = '') {
      if (id) {
        this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res = await delDevice({ id: id })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {})
      }
    },
    closeDevice() {
      this.deviceMap.form = {
        id: '',
        deviceCode: '',
        deviceName: '',
        deviceType: 1
      }
      this.deviceMap.visible = false
    },
    submitDevice() {
      this.$refs.deviceForm.validate(async valid => {
        if (valid) {
          let res = null
          if (this.deviceMap.form.id === '') {
            res = await addDevice({ ...this.deviceMap.form, deptId: sessionStorage.getItem('deptId') })
          } else {
            res = await updateDevice({ ...this.deviceMap.form, deptId: sessionStorage.getItem('deptId') })
          }
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.closeDevice()
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    async editRoom(row) {
      if (row) {
        this.roomMap.deviceId = row.id
        const res = await getDeviceRoomsList({ id: row.id })
        if (res.code === 200) {
          this.roomMap.list = res.data
        } else {
          this.$message.error(res.msg)
        }
      }
      this.roomMap.visible = true
    },
    async delRoom(id = '') {
      this.$confirm('确认删除该诊室?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const delIndex = this.roomMap.list.findIndex(v => v.id === id)
        if (delIndex !== -1) {
          this.roomMap.list.splice(delIndex, 1)
        }
      }).catch(() => {})
    },
    closeRoom() {
      this.roomMap.deviceId = ''
      this.roomMap.list = []
      this.roomMap.visible = false
    },
    async submitRoom() {
      const res = await updateDeviceRooms({
        id: this.roomMap.deviceId,
        roomIds: this.roomMap.list
      })
      if (res.code === 200) {
        this.$message.success('保存成功')
        this.closeRoom()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async getRoomList() {
      const res = await clinicList({deptId: sessionStorage.getItem('deptId')})
      if (res.code === 200) {
        this.addRoomMap.options = res.rows
      } else {
        this.$message.error(res.msg)
      }
    },
    addRoom() {
      this.addRoomMap.visible = true
      this.getRoomList()
      this.$nextTick(() => {
        this.$refs.addRoomForm.clearValidate()
      })
    },
    closeAddRoom() {
      this.addRoomMap.form = {
        roomId: ''
      }
      this.addRoomMap.visible = false
    },
    submitAddRoom() {
      this.$refs.addRoomForm.validate(async valid => {
        if (valid) {
          const room = this.roomMap.list.find(v => { return v.roomId === this.addRoomMap.form.roomId })
          if (!room) {
            this.roomMap.list.push({
              id: new Date().getTime(),
              roomId: this.addRoomMap.form.roomId,
              roomName: this.addRoomMap.options.find(v => { return v.clinicId === this.addRoomMap.form.roomId }).clinicName
            })
            this.$message.success('添加成功')
            this.closeAddRoom()
          } else {
            this.$message.error('该诊室已添加')
          }
        }
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
.callingNumbersManage{

}

.table{
  margin: 10px 0 0 0;
}

.room_table{
  margin: 10px 0 0 0;
}

.deviceDialog /deep/ .el-radio__original {
  display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
}
 
.deviceDialog /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>
